"use strict";

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

var _slicedToArray = require("/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.map");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

require("core-js/modules/es6.string.repeat");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringify = void 0;

var stringify_1 = require("./stringify");

var quote_1 = require("./quote");
/**
 * Root path node.
 */


var ROOT_SENTINEL = Symbol("root");
/**
 * Stringify any JavaScript value.
 */

function stringify(value, replacer, indent) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var space = typeof indent === "string" ? indent : " ".repeat(indent || 0);
  var path = [];
  var stack = new Set();
  var tracking = new Map();
  var unpack = new Map();
  var valueCount = 0;
  var _options$maxDepth = options.maxDepth,
      maxDepth = _options$maxDepth === void 0 ? 100 : _options$maxDepth,
      _options$references = options.references,
      references = _options$references === void 0 ? false : _options$references,
      _options$skipUndefine = options.skipUndefinedProperties,
      skipUndefinedProperties = _options$skipUndefine === void 0 ? false : _options$skipUndefine,
      _options$maxValues = options.maxValues,
      maxValues = _options$maxValues === void 0 ? 100000 : _options$maxValues; // Wrap replacer function to support falling back on supported stringify.

  var valueToString = replacerToString(replacer); // Every time you call `next(value)` execute this function.

  var onNext = function onNext(value, key) {
    if (++valueCount > maxValues) return;
    if (skipUndefinedProperties && value === undefined) return;
    if (path.length > maxDepth) return; // An undefined key is treated as an out-of-band "value".

    if (key === undefined) return valueToString(value, space, onNext, key);
    path.push(key);
    var result = builder(value, key === ROOT_SENTINEL ? undefined : key);
    path.pop();
    return result;
  };

  var builder = references ? function (value, key) {
    if (value !== null && (typeof value === "object" || typeof value === "function" || typeof value === "symbol")) {
      // Track nodes to restore later.
      if (tracking.has(value)) {
        unpack.set(path.slice(1), tracking.get(value)); // Use `undefined` as temporaray stand-in for referenced nodes

        return valueToString(undefined, space, onNext, key);
      } // Track encountered nodes.


      tracking.set(value, path.slice(1));
    }

    return valueToString(value, space, onNext, key);
  } : function (value, key) {
    // Stop on recursion.
    if (stack.has(value)) return;
    stack.add(value);
    var result = valueToString(value, space, onNext, key);
    stack["delete"](value);
    return result;
  };
  var result = onNext(value, ROOT_SENTINEL); // Attempt to restore circular references.

  if (unpack.size) {
    var sp = space ? " " : "";
    var eol = space ? "\n" : "";
    var wrapper = "var x".concat(sp, "=").concat(sp).concat(result, ";").concat(eol);

    var _iterator = _createForOfIteratorHelper(unpack.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            _value = _step$value[1];

        var keyPath = quote_1.stringifyPath(key, onNext);
        var valuePath = quote_1.stringifyPath(_value, onNext);
        wrapper += "x".concat(keyPath).concat(sp, "=").concat(sp, "x").concat(valuePath, ";").concat(eol);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return "(function".concat(sp, "()").concat(sp, "{").concat(eol).concat(wrapper, "return x;").concat(eol, "}())");
  }

  return result;
}

exports.stringify = stringify;
/**
 * Create `toString()` function from replacer.
 */

function replacerToString(replacer) {
  if (!replacer) return stringify_1.toString;
  return function (value, space, next, key) {
    return replacer(value, space, function (value) {
      return stringify_1.toString(value, space, next, key);
    }, key);
  };
}